import { cn } from '@utils';
import type { TypographyProps } from '../types/typography.types';
import React from 'react';

const Body3AccentTypography = React.forwardRef<HTMLParagraphElement, TypographyProps>(
	({ className, children, truncate = true, ...props }, ref) => (
		<p ref={ref} className={cn(className, `scroll-m-20 text-2xs font-medium ${truncate ? 'truncate' : ''}`)} {...props}>
			{children}
		</p>
	)
);

Body3AccentTypography.displayName = 'Body3AccentTypography';

export default Body3AccentTypography;
